<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item">
            <router-link to="/PressReleases/Page=1">
              <span class="text-primary">
                Press Releases
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">{{ LastNewsInfo.Topic }}</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div class="row align-items-center">
        <div class="col-lg-4">
          <div class="logImgFrame">
            <img :src="`//www.chanchao.com.tw/exhibitionfiles/news/${LastNewsInfo.NewsImg}`" width="75%" />
          </div>
        </div>
        <div class="col-lg-8">
          <h3>{{ LastNewsInfo.Topic }}</h3>

          <p class="mt-3">{{ LastNewsInfo.Brief }}</p>

          <p>Date: {{ LastNewsInfo.PostDate }}</p>
        </div>
      </div>

      <p>&zwnj;</p>

      <div class="DefaultStyleSheet" v-html="LastNewsInfo.Intro"></div>

      <p class="mt-4" v-if="LastNewsInfo.Url">
        Related Link : <a :href="LastNewsInfo.Url" target="_blank"> {{ LastNewsInfo.Url }}</a>
      </p>

      <p>&zwnj;</p>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        NewsInfo: {},
        LastNewsInfo: {},
      }
    },

    methods: {},

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },
    created() {
      $('.modal').modal('hide')

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      const vm = this

      //取得最新消息詳細資料
      vm.$http
        .get(
          `https://www.chanchao.com.tw/apiOnlineExpo/v1/LatestNewsDetail/${vm.exhcode}/${vm.$route.params.MyLastedNewsId}?Lang=en`
        )
        .then((response) => {
          vm.LastNewsInfo = response.data

          this.$nextTick(() => {
            $('.DefaultStyleSheet br').remove() // 删除所有 <br> 标签
          })
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })
    },
  }
</script>
<style lang="scss" scoped>
  .logImgFrame {
    width: 350px;
    min-height: 300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
